/*
 * Adds/removes options of the element "degree", depending on which option is selected for the element "training".
 */
export default function () {
    const trainingOptionSecondary = 1;
    const $trainingElem = $('#item-id-110');
    const $degreeElem = $('#item-id-120');
    const $allDegreeOptions = $('option', $degreeElem);

    updateDegreeElement();

    $trainingElem.on('change', function () {
        updateDegreeElement();
    });

    function updateDegreeElement(): void {
        const previousValue = $trainingElem.data('prev');
        const newValue = $trainingElem.val();
        const init = typeof previousValue === 'undefined';

        if(init || (previousValue !== newValue && (previousValue == trainingOptionSecondary || newValue == trainingOptionSecondary))) {
            if (newValue == trainingOptionSecondary) {
                $degreeElem.empty().append(
                    $allDegreeOptions.not(':eq(1), :eq(2), :eq(3), :eq(4)') // Don't show degree options 1-4, when training option "secondary" is selected
                );
            } else {
                $degreeElem.empty().append(
                    $allDegreeOptions.not(':eq(5), :eq(6), :eq(7)') // Don't show degree options 5-7, when other training option then "secondary" is selected
                );
            }
            if(!init) {
                $degreeElem.val(-1); // Reset previous selection
            }
        }

        $trainingElem.data('prev', newValue);
    }
}